import React from 'react';
import { DeviceSize } from '../basic/DeviceSize';
import styled, { css } from 'styled-components/macro';
import { blackLogo } from '../../assets';
import { NavLink } from 'react-router-dom';
import { useMessageGetter } from 'react-message-context';

const M2_KODIT_HOME = 'https://m2kodit.fi/omam2/?utm_source=omam2&utm_medium=website&utm_campaign=omam2_kirjautuminen';

interface HomeLogoProps {
  margin?: string;
  toM2KoditHome?: boolean;
}

const sharedLogoStyles = css<{ margin?: string }>`
  z-index: 1;

  img {
    width: 250px;

    @media print {
      height: 50px;
    }

    @media ${DeviceSize.desktopS} {
      width: 128px;
    }
  }

  @media ${DeviceSize.desktopS} {
    display: flex;
    margin: 0;
    position: unset;
    top: 0;
    left: 0;
    order: 0;
  }

  @media print {
    position: absolute;
    margin: 0 0 0 0;
    left: unset;
    right: 0;
  }
`;

const ExternalLink = styled.a<{ margin?: string }>`
  ${sharedLogoStyles}
`;

const InternalLink = styled(NavLink)<{ margin?: string }>`
  ${sharedLogoStyles}
`;
const HomeLogo = ({ margin, toM2KoditHome = false }: HomeLogoProps) => {
  const t = useMessageGetter('navigation');

  if (toM2KoditHome) {
    return (
      <ExternalLink href={M2_KODIT_HOME} margin={margin} id="homelogo">
        <img src={blackLogo} alt="M2 logo" aria-label={t('m2koditLink')} />
      </ExternalLink>
    );
  }

  return (
    <InternalLink to="/" exact margin={margin} id="homelogo">
      <img src={blackLogo} alt="M2 logo" aria-label={t('omaM2Link')} />
    </InternalLink>
  );
};

export default HomeLogo;
